'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIconXs } from '@lichtblick/icons/svg/info/info-xs';
import classNames from 'classnames';
import { Text } from '../../atoms/text/text';
import { Label } from '../label/label';
import { FieldFooter } from '../legacy-field-footer/field-footer';
import { Tooltip } from '../tooltip/tooltip';
import styles from './textfield.module.scss';
/**
 * @deprecated Use `Textfield` instead.
 *
 * Generic text input component with some basic setup to be used as foundation for all kinds of text input types.
 * Ref needs to be forwarded to be compatible with form packages like react-hook-form.
 */ export const Textfield = ({ bold: isBold, centered: isCentered, className, 'data-testid': testId, disabled: isDisabled, icon, id, label, leftSlot, name, onTooltipClick, ref, rightSlot, statusLabel, statusType = 'default', subLabel, suffixText, tooltipContent, ...props })=>{
    const inputId = id || name;
    const labelId = label && inputId && `${inputId}_label`;
    const statusId = statusLabel && inputId && `${inputId}_validationMessage`;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.wrapper, className),
        children: [
            Boolean(label || onTooltipClick || tooltipContent) && /*#__PURE__*/ _jsxs("div", {
                className: styles['label-wrapper'],
                children: [
                    Boolean(label) && /*#__PURE__*/ _jsxs(Label, {
                        bold: true,
                        htmlFor: inputId,
                        id: labelId,
                        children: [
                            label,
                            Boolean(subLabel) && /*#__PURE__*/ _jsx(Text, {
                                className: styles['sub-label'],
                                size: "xs",
                                children: subLabel
                            })
                        ]
                    }),
                    (Boolean(onTooltipClick) || Boolean(tooltipContent)) && /*#__PURE__*/ _jsx(Tooltip, {
                        content: tooltipContent,
                        children: /*#__PURE__*/ _jsx(InfoIconXs, {
                            className: styles['info-icon'],
                            onClick: onTooltipClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classNames('input-row', styles['input-row'], isDisabled && styles['input-row-disabled'], statusType !== 'default' && styles[`input-row-${statusType}`]),
                children: [
                    leftSlot && /*#__PURE__*/ _jsx("div", {
                        className: styles['slot-left'],
                        children: leftSlot
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        ...props,
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        className: classNames(styles.input, Boolean(rightSlot) && styles['input-right-slot'], Boolean(leftSlot) && styles['input-left-slot'], isCentered && styles['input-center'], isBold && styles['input-bold']),
                        "data-testid": testId || inputId,
                        disabled: isDisabled,
                        id: inputId,
                        name: name,
                        ref: ref
                    }),
                    Boolean(rightSlot || suffixText) && /*#__PURE__*/ _jsxs("div", {
                        className: styles['slot-right'],
                        children: [
                            Boolean(suffixText) && /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                className: styles['suffix-text'],
                                children: suffixText
                            }),
                            rightSlot
                        ]
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                icon: icon,
                id: statusId,
                label: statusLabel,
                state: statusType
            })
        ]
    });
};

//# sourceMappingURL=textfield.js.map